var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-start space-x-3"},[_c('div',{staticClass:"flex-shrink-0 text-gray-400"},[_vm._t("icon")],2),_c('div',{staticClass:"text-sm leading-5 text-slate-800"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }